package dev.kuml.portal.web.i18n.strings

public interface ProjectsStrings {
    public val pageTitle: String
    public val newProject: String
    public val emptyState: String
    public val lastChangedUnknown: String
    public val renameAction: String
    public val renameAriaLabel: String
    public val deleteAction: String
    public val deleteAriaLabel: String
    public val deleteFailed: String
    public val projectLimitReachedUnknown: String

    /** DISPLAY-ONLY localisation of the server-persisted default project name (see
     * `projects/DefaultNameDisplay.kt`'s KDoc for why the wire value itself is never translated). */
    public val defaultProjectNameDisplay: String

    public fun projectLimitReached(limit: Int): String

    public fun createdAt(
        time: String,
        index: Int?,
    ): String

    public fun createdAtUnknown(index: Int?): String

    public fun lastChanged(date: String): String

    public fun deleteConfirmQuestion(name: String): String

    public val allPlainStrings: List<String>
        get() =
            listOf(
                pageTitle,
                newProject,
                emptyState,
                lastChangedUnknown,
                renameAction,
                renameAriaLabel,
                deleteAction,
                deleteAriaLabel,
                deleteFailed,
                projectLimitReachedUnknown,
                defaultProjectNameDisplay,
            )
}

public object ProjectsStringsDe : ProjectsStrings {
    override val pageTitle = "Ihre Projekte"
    override val newProject = "+ Neues Projekt"
    override val emptyState = "Sie haben noch keine Projekte. Legen Sie Ihr erstes an."
    override val lastChangedUnknown = "Zuletzt geändert"
    override val renameAction = "✎ Umbenennen"
    override val renameAriaLabel = "Projekt umbenennen"
    override val deleteAction = "🗑 Löschen"
    override val deleteAriaLabel = "Projekt löschen"
    override val deleteFailed = "Löschen fehlgeschlagen. Bitte erneut versuchen."
    override val projectLimitReachedUnknown =
        "Das Projekt-Limit Ihres Plans ist erreicht. Löschen Sie ein Projekt, um Platz zu schaffen."
    override val defaultProjectNameDisplay = "Unbenanntes Projekt"

    override fun projectLimitReached(limit: Int): String =
        "Free-Plan: maximal $limit Projekte. Löschen Sie ein Projekt, um Platz zu schaffen."

    override fun createdAt(
        time: String,
        index: Int?,
    ): String = "Erstellt: $time" + (index?.let { " · #$it" } ?: "")

    override fun createdAtUnknown(index: Int?): String = "Neu angelegt" + (index?.let { " · #$it" } ?: "")

    override fun lastChanged(date: String): String = "Zuletzt geändert: $date"

    override fun deleteConfirmQuestion(name: String): String = "Projekt \"$name\" löschen? Das kann nicht rückgängig gemacht werden."
}

public object ProjectsStringsEn : ProjectsStrings {
    override val pageTitle = "Your projects"
    override val newProject = "+ New project"
    override val emptyState = "You don't have any projects yet. Create your first one."
    override val lastChangedUnknown = "Last changed"
    override val renameAction = "✎ Rename"
    override val renameAriaLabel = "Rename project"
    override val deleteAction = "🗑 Delete"
    override val deleteAriaLabel = "Delete project"
    override val deleteFailed = "Delete failed. Please try again."
    override val projectLimitReachedUnknown =
        "Your plan's project limit has been reached. Delete a project to make room."
    override val defaultProjectNameDisplay = "Untitled project"

    override fun projectLimitReached(limit: Int): String = "Free plan: up to $limit projects. Delete a project to make room."

    override fun createdAt(
        time: String,
        index: Int?,
    ): String = "Created: $time" + (index?.let { " · #$it" } ?: "")

    override fun createdAtUnknown(index: Int?): String = "Just created" + (index?.let { " · #$it" } ?: "")

    override fun lastChanged(date: String): String = "Last changed: $date"

    override fun deleteConfirmQuestion(name: String): String = "Delete project \"$name\"? This cannot be undone."
}
